import React from 'react'
import Menu from './Menu'
import { NavLink } from "react-router-dom"

/**
  * @class Header
  * Header contains Menu
*/
class Header extends React.Component {

  /* By default : we'll see the header */
  constructor(props) {
    super(props)
    this.state = {
      showHeader : true,
      menuOpened: false
    }
    this.lastScrollPosition = 0
    this.handleScroll = this.handleScroll.bind(this)
    this.setMenuOpened = this.setMenuOpened.bind(this)
    this.openMenu = this.openMenu.bind(this)
    this.closeMenu = this.closeMenu.bind(this)
    this.toggleMenu = this.toggleMenu.bind(this)
  }

  /* Listen the scroll position */
  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }
  /**
    * @class Header
    * @method handlescroll
    * Show header if scrollbar is at the top (until 70px) and when we scroll up.
  */
  handleScroll(event) {
    let state = this.state
    state.showHeader = this.lastScrollPosition > window.scrollY || window.scrollY < 70
    this.setState(state)
    this.lastScrollPosition = window.scrollY
  }

  setMenuOpened(menuOpened) {
    let state = this.state;
    state.menuOpened = menuOpened;
    this.setState(state);
  }

  openMenu() {
    this.setMenuOpened(true);
  }

  closeMenu() {
    this.setMenuOpened(false);
  }

  toggleMenu() {
    this.setMenuOpened(!this.state.menuOpened);
  }

  render() {
    /* Change style when showHeader changes */
    //const position = this.state.showHeader ? 'fixed' : 'absolute'
    const position = ''
    let menuClassName = 'menu';
    if (this.state.menuOpened) {
      menuClassName += ' menu--opened';
    }
    return <header>
      <div className="fixed-bar" tabIndex="0" style={{position}}></div>

      <div className={menuClassName} style={{position}}>

        <NavLink className="logo-link" exact to={"/"}>
          <img src={ "/images/logos/cosmic-small.png" } alt="Cosmic" />
        </NavLink>

        <div className="bg"></div>
        <div className="burger" onClick={this.toggleMenu} tabIndex="0">
          <span className="icon-bar"></span>
          <span className="icon-bar"></span>
          <span className="icon-bar"></span>
        </div>

        <div className="menu--open" tabIndex="0">
          <Menu closeMenu={this.closeMenu} />
        </div>

        <div className="menu__social">
          <a className="menu__social__link" href="https://twitter.com/altaviacosmic" target="_blank" rel="noopener noreferrer">
            <img src={ "/images/logos/logo-twitter.png" } alt="Twitter" />
          </a>
          <a className="menu__social__link" href="https://www.instagram.com/altaviacosmic/" target="_blank" rel="noopener noreferrer">
            <img src={ "/images/logos/logo-instagram.png" } alt="Instagram" />
          </a>
          <a className="menu__social__link" href="https://www.facebook.com/Altavia-Cosmic-2076470079318178/" target="_blank" rel="noopener noreferrer">
            <img src={ "/images/logos/logo-fb.png" } alt="Facebook" />
          </a>
        </div>
      </div>
    </header>
  }
}

export default Header







// WEBPACK FOOTER //
// ./src/components/Header/index.jsx